// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"294":"0c4fb4bb808a05f7","3435":"43dc74318669aebb"}[chunkId] + ".css";
};